export const en = {
  'celebration.birthday.label': 'Birthday greeting',
  'celebration.birthday.greeting': 'Happy birthday, {name}!',
  'celebration.birthday.greetingNoName': 'Happy birthday!',
  'celebration.birthday.member': 'Everyone at {gym} wishes you a great year ahead.',
  'celebration.birthday.staff': 'The whole team at {gym} wishes you a great year ahead.',
  'celebration.dismiss': 'Dismiss',
  'birthdays.today.title': 'Birthdays today',
  'birthdays.today.description': 'Colleagues at your branches who celebrate today.',
  'birthdays.today.sendWishes': 'Send wishes',
  'birthdays.today.sendWishesTo': 'Send wishes to {name}',
  'birthdays.today.wishMessage': 'Happy birthday, {name}! Wishing you a wonderful year.',
  'birthdays.desk.badge': 'Birthday today',
  'birthdays.field.dateOfBirth': 'Date of birth',
  'birthdays.field.dateOfBirthHint': 'Seen by managers and the person. Colleagues only see that it is their birthday.',
  'birthdays.profile.title': 'Birthday',
  'birthdays.profile.description': 'On the day, colleagues see that it is your birthday, never the date or your age.',
  'birthdays.profile.saved': 'Birthday saved',
  'birthdays.settings.title': 'Birthdays',
  'birthdays.settings.description': 'Greet members and staff on their birthday from 9:00, gym time.',
  'birthdays.settings.members': 'Greet members',
  'birthdays.settings.membersHint': 'A greeting in the app, a celebration in the member area and a cake at the desk.',
  'birthdays.settings.staff': 'Greet staff',
  'birthdays.settings.staffHint': 'A greeting and a celebration for the person, and "Birthdays today" for their colleagues.',
  'birthdays.settings.email': 'Also by email',
  'birthdays.settings.emailHint': 'To everyone who has not turned email off.',
  'birthdays.settings.sms': 'Also by SMS',
  'birthdays.settings.smsHint': 'Texts cost money. Only members who agreed to offers by SMS, between 10:00 and 21:00.',
};

export const ka: Record<keyof typeof en, string> = {
  'celebration.birthday.label': 'დაბადების დღის მილოცვა',
  'celebration.birthday.greeting': 'გილოცავთ დაბადების დღეს, {name}!',
  'celebration.birthday.greetingNoName': 'გილოცავთ დაბადების დღეს!',
  'celebration.birthday.member': '{gym}-ის გუნდი გისურვებთ ბედნიერ და ენერგიულ წელს.',
  'celebration.birthday.staff': '{gym}-ის მთელი გუნდი გისურვებთ წარმატებულ წელს.',
  'celebration.dismiss': 'დახურვა',
  'birthdays.today.title': 'დღევანდელი დაბადების დღეები',
  'birthdays.today.description': 'კოლეგები თქვენი ფილიალებიდან, ვისაც დღეს დაბადების დღე აქვს.',
  'birthdays.today.sendWishes': 'მილოცვა',
  'birthdays.today.sendWishesTo': 'მილოცვის გაგზავნა: {name}',
  'birthdays.today.wishMessage': 'გილოცავ დაბადების დღეს, {name}! გისურვებ შესანიშნავ წელს.',
  'birthdays.desk.badge': 'დღეს დაბადების დღეა',
  'birthdays.field.dateOfBirth': 'დაბადების თარიღი',
  'birthdays.field.dateOfBirthHint': 'თარიღს ხედავენ მენეჯერები და თავად თანამშრომელი. კოლეგები მხოლოდ იმას ხედავენ, რომ დაბადების დღეა.',
  'birthdays.profile.title': 'დაბადების დღე',
  'birthdays.profile.description': 'ამ დღეს კოლეგები დაინახავენ, რომ თქვენი დაბადების დღეა, მაგრამ არასდროს თარიღს ან ასაკს.',
  'birthdays.profile.saved': 'დაბადების თარიღი შენახულია',
  'birthdays.settings.title': 'დაბადების დღეები',
  'birthdays.settings.description': 'წევრებისა და თანამშრომლების მილოცვა დაბადების დღეს, დარბაზის დროით 9:00-დან.',
  'birthdays.settings.members': 'წევრების მილოცვა',
  'birthdays.settings.membersHint': 'მილოცვა აპლიკაციაში, ზეიმი წევრის გვერდზე და ტორტის ნიშანი რეცეფციაზე.',
  'birthdays.settings.staff': 'თანამშრომლების მილოცვა',
  'birthdays.settings.staffHint': 'მილოცვა და ზეიმი თავად თანამშრომლისთვის, კოლეგებისთვის კი „დღევანდელი დაბადების დღეები“.',
  'birthdays.settings.email': 'ასევე ელფოსტით',
  'birthdays.settings.emailHint': 'ყველას, ვისაც ელფოსტა არ გამოურთავს.',
  'birthdays.settings.sms': 'ასევე SMS-ით',
  'birthdays.settings.smsHint': 'SMS ფასიანია. მხოლოდ წევრებს, ვინც SMS-ით შეთავაზებებზე თანხმობა მისცა, 10:00-დან 21:00-მდე.',
};
